export default __webpack_public_path__ + "static/media/30.132a2ca5.jpeg";